import { render } from "./file-manager-edit.vue?vue&type=template&id=fcbef5fa"
import script from "./file-manager-edit.vue?vue&type=script&lang=js"
export * from "./file-manager-edit.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ns/Desktop/entwicklung/github/corpred_desk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__